import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
import { DragulaService } from "ng2-dragula/ng2-dragula";
import * as _ from "lodash";

declare var alertify: any;
@Component({
  templateUrl: "./recommodProduct.html",
})
export class ProductRecommend implements OnInit {
  constructor(
    private router: Router,
    private http: HttpService,
    private dragulaService: DragulaService
  ) {
    dragulaService.dropModel.subscribe((value) => {
      // console.log("drop: ${value[0]}");
      this.onDrop(value.slice(1));
    });
    dragulaService.setOptions("evented-bag", {
      copy: false,
    });
  }

  public data: any = [];

  private imagePath: string = "";

  private page = {
    pageNumber: 1,
    pageSize: 10,
    genreName: "",
    name: "",
    defRecommend: "",
  };

  ngOnInit(): void {
    this.getPath();
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  private getData() {
    let data = { ...this.page };
    data.pageNumber--;
    this.http.getData(API.product, data).then((res) => {
      this.data = res.data;
      for (let i = 0; i < this.data.content.length; i++) {
        if (this.data.content[i].image != "") {
          this.data.content[i].image =
            this.imagePath + this.data.content[i].image;
        }
      }
    });
  }

  private recommondProduct(id: number) {
    this.http
      .getData(API.product + "/setDefRecommodProduct/" + id)
      .then((res) => {
        let dt = res;
        let self = this;
        if (dt.status.code == 0 || dt.status.code == "0") {
          alertify.success(dt.status.message);
          self.getData();
        } else {
          alertify.error(dt.status.message);
        }
      });
  }

  public updateSort() {
    this.http.postData(API.productSort, this.postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }

  private postData = [];

  private getList() {
    this.postData = [];
    let sortData = _.cloneDeep(this.data.content);
    sortData.forEach((data, i) => {
      this.postData.push({
        id: data.id,
        rank: i + (this.page.pageNumber - 1) * this.page.pageSize,
      });
    });
  }

  public dragChange(e) {
    console.log(e);
  }

  private ngOnDestroy() {
    this.dragulaService.destroy("evented-bag");
  }

  public sortDown(item) {
    if (item.ranks < 0) {
      return;
    }
    let postData = [{ id: item.id, rank: item.ranks + 1 }];
    this.http.postData(API.productSort, postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.getData();
      } else {
        alertify.error(data.status.message);
      }
    });
  }
  public sortUp(item) {
    if (item.ranks <= 0) {
      return;
    }
    let postData = [{ id: item.id, rank: item.ranks - 1 }];
    this.http.postData(API.productSort, postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.getData();
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  public inputSort(item) {
    alertify.prompt(
      "Sort",
      "Input sort number",
      item.ranks,
      (e, val) => {
        let postData = [{ id: item.id, rank: val }];
        this.http.postData(API.productSort, postData).then((res) => {
          let data = res;
          if (data.status.code == 0 || data.status.code == "0") {
            this.getData();
          } else {
            alertify.error(data.status.message);
          }
        });
      },
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/product/RecommodProduct.componment.ts